import React, { useState } from "react";
import ReCAPTCHA from "react-google-recaptcha";
import { UseGlobellogin } from "./Logincontaxt.jsx/Logincontex";
import { BASE_URL } from "../Config/Config";
import { RECAPTCHA_SITE_KEY } from "./GlobelHelper/GlobelRechpcha";
import { NavLink } from "react-router-dom";
import GoogleSignin from "./Googlesignup";
import styled from "styled-components";
const Signin = ({ setIsSignin, toggleForm }) => {
  const [formMessage, setFormMessage] = useState("");
  const [enableSubmit, setEnableSubmit] = useState(true);
  const { setsuccessfully } = UseGlobellogin();

  const [data, setData] = useState({
    user_input: "",
    password: ""
  });

  const updateInput = (e) => {
    const { name, value } = e.target;
    setData((prev) => ({ ...prev, [name]: value }));
  };

  const handleCaptchaChange = (value) => {
    if (value) setEnableSubmit(false);
  };

  const isEmail = (value) => /^\S+@\S+\.\S+$/.test(value);
    const isMobile = (value) => /^[6-9]\d{9}$/.test(value);

  const handleSubmit = async (e) => {
    e.preventDefault();
     const { user_input, password } = data;

     if (!user_input || !password) {
    setFormMessage("All fields are required.");
    return;
  }

  if (!isEmail(user_input) && !isMobile(user_input)) {
    setFormMessage("Please enter a valid email or mobile number.");
    return;
  }

  if (password.length < 6) {
    setFormMessage("Password must be at least 6 characters long.");
    return;
  }
    try {
      const response = await fetch(`${BASE_URL}/usersignup/`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(data)
      });

      const result = await response.json();
      if (response.ok) {
        setsuccessfully(result.message);
        setTimeout(() => setsuccessfully(""), 10000);
        setData({ user_input: "", password: "" });
        setIsSignin(false);
      } else {
        setFormMessage(result.message);
      }
    } catch (err) {
      setFormMessage("Something went wrong. Please try again.");
    }
  };
  return (
    <Wrappaer>
      <section className="auth-section auth-fullscreen">
        <div className="p-0">
          <div className="row">
            <div className="col-12 text-center p-0">
              <h4 className="display-5 fw-bold p-0">Sign Up</h4>
              <div className="text-center mb-4 px-4">

                <p className="text-lg font-semibold text-gray-800 leading-snug text-primary">
                  Welcome to <span className="text-indigo-600 font-bold">Auratech</span> — your gateway to smart learning & seamless tech solutions. Let’s grow together!
                </p>
                <p>
                  Already have an account?{" "}
                  <span
                    className="text-primary cursor-pointer"
                    onClick={() => setIsSignin(false)}
                    style={{ cursor: "pointer", fontWeight: 700 }}
                  >
                    Login
                  </span>
                </p>
              </div>
            </div>
          </div>

          <div className="row justify-content-center g-0">
            <div className="col-12 col-lg-10 col-xl-10 ">
              <div className="row align-items-stretch g-0">
                {/* Form */}
                <div className="col-12 col-lg-6 mb-4 mb-lg-0">
                  <div className="login-card p-4 p-md-5 h-100 d-flex flex-column justify-content-center">
                    <form onSubmit={handleSubmit}>
                      <div className="form-floating mb-3">
                        <input
                          type="text"
                          className="form-control"
                          id="user_input"
                          name="user_input"
                          placeholder="Email or Mobile Number"
                          value={data.user_input}
                          onChange={updateInput}
                          required
                        />
                        <label htmlFor="user_input">Email or Mobile Number</label>
                      </div>

                      <div className="form-floating mb-3">
                        <input
                          type="password"
                          className="form-control"
                          id="password"
                          name="password"
                          placeholder="Password"
                          value={data.password}
                          onChange={updateInput}
                          required
                        />
                        <label htmlFor="password">Password</label>
                      </div>

                     {formMessage && (
  <div className="text-danger fw-bold mt-2">{formMessage}</div>
)}

                      <div className="mb-3 d-flex justify-content-start">
                        <div style={{ transform: "scale(0.70)", transformOrigin: "0 0" }}>
                          <ReCAPTCHA
                            sitekey={RECAPTCHA_SITE_KEY}
                            onChange={handleCaptchaChange}
                          />
                        </div>
                      </div>

                      <div className="btn-group d-grid">
                        <button
                          className="th-btn style3"
                          type="submit"
                          disabled={enableSubmit}
                        >
                          Sign Up <i className="fas fa-arrow-right ms-2" />
                        </button>
                      </div>
                    </form>
                  </div>
                </div>

                {/* Divider */}
                <div className="col-12 col-lg-1 d-flex flex-column align-items-center justify-content-center my-3 my-lg-0">
        <div className="d-lg-block d-none bg-dark" style={{ width: 1, height: "100%", opacity: 0.1 }} />
        <div className="d-lg-none d-block bg-dark" style={{ width: "100%", height: 1, opacity: 0.1 }} />
        <span className="my-2">or</span>
        <div className="d-lg-block d-none bg-dark" style={{ width: 1, height: "100%", opacity: 0.1 }} />
        <div className="d-lg-none d-block bg-dark" style={{ width: "100%", height: 1, opacity: 0.1 }} />
      </div>


                {/* Social Login */}
                <div className="col-12 col-lg-4 ">
                  <div className="sigin-card d-flex flex-column align-items-center justify-content-evenly h-100 p-4">
                    <div className="mobile-logo">
                      <NavLink to="/">
                        <img
                          src="/assets/img/AA_LOgo_Black.png"
                          alt="Auratech Academy"style={{ maxWidth: "100%", height: "auto" }}
                        />
                      </NavLink>
                    </div>
                    <GoogleSignin mode="Signup" toggleForm={toggleForm} />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </Wrappaer>


  );
};

const Wrappaer = styled.section`
  .auth-section {
    // min-height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 2rem 1rem;
    // background-color: #f4f7fa; 
  }

  .login-card {
    transition: all 0.5s ease-in-out;
    border: 1px solid #b3cae0ff;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.06);
    background-color: #ffffff;
    border-radius: 12px;
  }

  .login-card:hover {
    box-shadow: 0 8px 20px rgba(0, 0, 0, 0.08);
    transform: translateY(-8px);
  }

  .login-card input:focus {
    border-color: #0d6efd;
    box-shadow: 0 0 0 0.2rem rgba(13, 110, 253, 0.25);
  }

  .login-card .th-btn {
    transition: background-color 0.4s ease, transform 0.3s;
  }

 .login-card .th-btn:hover {
    background-color: #084298;
    transform: translateY(-2px);
  }

  .sigin-card {
    padding: 1rem;
  }

  @media (max-width: 768px) {
    .login-card,
    .sigin-card {
      padding: 1.5rem;
    }

    .auth-section h4 {
      font-size: 1.8rem;
    }

    .text-lg {
      font-size: 1rem;
    }

    .btn-group {
      flex-direction: column;
    }

    .mobile-logo {
      display: block;
      text-align: center;
      margin-top: 2rem;
    }
  }
`;



export default Signin;
